import { Component, Input, OnInit } from '@angular/core';
import { PayoutRefund } from '@eightcap/core';

@Component({
    selector: 'eig-refund-table',
    templateUrl: './refund-table.component.html',
    styleUrls: ['./refund-table.component.scss'],
})
export class RefundTableComponent implements OnInit {

    @Input() refundList: PayoutRefund[];

    displayedColumns: string[] = [
        'id',
        'amount',
        'status',
        'decline_code',
        'decline_reason',
    ];

    constructor() {}

    ngOnInit(): void {
        if (this.refundList.length) {
            this.refundList[0].deposit_reference_id
                ? this.showDepositIDColumns()
                : this.showWithdrawIDColumns();
        }
    }

    private showWithdrawIDColumns(): void {
        this.displayedColumns = [
            'id',
            'amount',
            'withdrawal_reference_id',
            'status',
            'decline_code',
            'decline_reason',
        ];
    }

    private showDepositIDColumns(): void {
        this.displayedColumns = [
            'id',
            'amount',
            'deposit_reference_id',
            'status',
            'decline_code',
            'decline_reason',
        ];
    }
}
